import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const Container = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.xxSmallBold}
  padding: ${({ theme }) => theme.spacing(2, 4, 2, 2)};
  align-content: center;
  color: ${({ theme, type }) => theme.commons.tags[type].color};
  background: ${({ theme, type }) => theme.commons.tags[type].background};
  border-radius: ${({ theme, rounded }) =>
    rounded ? theme.spacing(2, 5, 5, 2) : theme.spacing(0, 4, 4, 0)};
  position: relative;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-transform: uppercase;
`;

const IconContainer = styled.div`
  margin-right: ${({ theme }) => theme.spaces.space_4};
  display: flex;
`;

function Tag({ type, rounded, text, icon, onClick }) {
  return (
    <Container type={type} rounded={rounded} onClick={onClick}>
      {icon && <IconContainer aria-hidden="true">{icon}</IconContainer>}
      {text}
    </Container>
  );
}

Tag.defaultProps = {
  rounded: false,
  type: 'default',
};

Tag.propTypes = {
  rounded: PropTypes.bool,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['default', 'brand', 'warning', 'deals', 'danger']),
  icon: PropTypes.object,
  onClick: PropTypes.func,
};

export default Tag;
